import React, { useEffect } from "react";
import { useMetrics } from "@/modules/app/useMetrics";

const FoucFix: React.FC = () => {
  const { emit } = useMetrics();
  useEffect(() => {
    document.documentElement.className = document.documentElement.className.replace(
      "no-js",
      "js"
    );

    emit("PageReady");
  }, [emit]);
  return null;
};

export default FoucFix;
